import { render, staticRenderFns } from "./onlyPublish.vue?vue&type=template&id=11a25506&scoped=true&"
import script from "./onlyPublish.vue?vue&type=script&lang=js&"
export * from "./onlyPublish.vue?vue&type=script&lang=js&"
import style0 from "./onlyPublish.vue?vue&type=style&index=0&id=11a25506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a25506",
  null
  
)

export default component.exports